import type { Locale } from "@bloom/types";
import { cn } from "../cn.ts";

export interface LocaleSwitcherProps {
  current: Locale;
  onChange: (locale: Locale) => void;
  className?: string;
}

export function LocaleSwitcher({ current, onChange, className }: LocaleSwitcherProps) {
  return (
    <div
      role="radiogroup"
      aria-label="Language"
      className={cn(
        "inline-flex items-center gap-1 rounded-full bg-[var(--brand-pink-soft)] p-1",
        className,
      )}
    >
      {(["th", "en"] as const).map((l) => (
        <button
          key={l}
          type="button"
          role="radio"
          aria-checked={current === l}
          onClick={() => onChange(l)}
          className={cn(
            "rounded-full px-3 py-1 text-xs font-semibold uppercase transition-colors",
            current === l
              ? "bg-[var(--brand-ink)] text-[var(--brand-paper)]"
              : "text-[var(--brand-muted)] hover:text-[var(--brand-ink)]",
          )}
        >
          {l}
        </button>
      ))}
    </div>
  );
}
